import React, { useEffect, useState } from "react";
import SheetSkeleton from "../sheet/sheetSkeleton";
import { Spin } from "antd";
import OtpVerifier from "./otpVerifier";
import AskNewPin from "./askNewPin";

const SetUserPin = ({ open, close, pinSetted, userId }) => {
  const [verified, setVerified] = useState(false);
  const [showVerifier, setShowVerifier] = useState(false);
  useEffect(() => {
    if (!verified) setShowVerifier(true);
  }, []);
  const doneVerify = () => {
    setVerified(true);
    setShowVerifier(false);
  };
  if (verified)
    return (
      <AskNewPin
        open={verified}
        userId={userId}
        close={close}
        created={pinSetted}
      />
    );
  else
    return (
      <OtpVerifier
        open={!verified}
        close={close}
        verified={doneVerify}
        userId={userId}
      />
    );
};

export default SetUserPin;
